export default "__VITE_ASSET__BkbLnr6z__"